import { colors } from '../../colors';
var promoBanner = {
  bgColor: colors.ivory,
  fontColor: colors.darkNight,
  textColorDark: colors.darkNight,
  textColorLight: colors.white
};
export default promoBanner;